import { render, staticRenderFns } from "./worktypes.vue?vue&type=template&id=6f061f26"
import script from "./worktypes.vue?vue&type=script&lang=js"
export * from "./worktypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports